// extracted by mini-css-extract-plugin
module.exports = {"root":"CataloghiBlock_root__x3dyN","title":"CataloghiBlock_title__Y2Bam","list":"CataloghiBlock_list__sLacp","rotation":"CataloghiBlock_rotation__iBUVK"};